const DEBUG = String(process.env.NEXT_PUBLIC_DEBUG_AUTH || '').toLowerCase() === 'true'
const clog = (...args) => { if (DEBUG) try { console.log('[SESSION][CLIENT]', ...args) } catch {} }

// 24 hours in milliseconds
const SESSION_TIMEOUT = 24 * 60 * 60 * 1000

class SessionManager {
  constructor() {
    this.lastActivity = Date.now()
    this.isActive = true
    this.checkInterval = null
    this.activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
  }

  init() {
    if (typeof window === 'undefined') return // Server-side guard
    
    clog('SessionManager initialized')
    
    // Load last activity from localStorage
    const stored = localStorage.getItem('lastActivity')
    if (stored) {
      this.lastActivity = parseInt(stored, 10)
    }

    // Check if session should be expired on page load
    this.checkSessionOnLoad()

    // Set up activity listeners
    this.setupActivityListeners()

    // Start periodic session checks
    this.startSessionCheck()
  }

  checkSessionOnLoad() {
    const now = Date.now()
    const timeSinceLastActivity = now - this.lastActivity
    
    clog('Time since last activity:', Math.round(timeSinceLastActivity / 1000 / 60), 'minutes')
    
    if (timeSinceLastActivity > SESSION_TIMEOUT) {
      clog('Session expired on load, forcing logout')
      this.forceLogout()
      return true
    }
    
    return false
  }

  setupActivityListeners() {
    this.activityEvents.forEach(event => {
      document.addEventListener(event, this.updateActivity.bind(this), true)
    })

    // Also listen for visibility changes
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.updateActivity()
      }
    })
  }

  updateActivity() {
    this.lastActivity = Date.now()
    localStorage.setItem('lastActivity', this.lastActivity.toString())
    this.isActive = true
    clog('Activity updated')
  }

  startSessionCheck() {
    // Check every 5 minutes
    this.checkInterval = setInterval(() => {
      this.checkSession()
    }, 5 * 60 * 1000)
  }

  checkSession() {
    const now = Date.now()
    const timeSinceLastActivity = now - this.lastActivity
    
    if (timeSinceLastActivity > SESSION_TIMEOUT) {
      clog('Session timeout detected')
      this.forceLogout()
    }
  }

  async forceLogout() {
    clog('Forcing logout due to session timeout')
    
    try {
      // Clear local storage
      localStorage.removeItem('lastActivity')
      
      // Call logout API to clear server session
      await fetch('/api/auth/logout', { 
        method: 'POST', 
        credentials: 'include' 
      })
    } catch (error) {
      clog('Error during forced logout:', error)
    }
    
    // Redirect to login with timeout message
    window.location.href = '/login?timeout=true'
  }

  destroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
    
    this.activityEvents.forEach(event => {
      document.removeEventListener(event, this.updateActivity.bind(this), true)
    })
  }
}

// Create singleton instance
const sessionManager = new SessionManager()

export default sessionManager
